// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FinalizationPreselectionVO } from '@project/model/vo/project.vo';
import { ArticleDataService } from '@article/service/article-data.service';

@Component({
  standalone: false,
  selector: 'app-choose-finalization-preselection',
  templateUrl: './choose-finalization-preselection.component.html',
  styleUrls: ['./choose-finalization-preselection.component.scss']
})
export class ChooseFinalizationPreselectionComponent implements OnInit {

  @Input()
  public oldData: FinalizationPreselectionVO;
  @Input()
  public newData: FinalizationPreselectionVO;
  @Output()
  public finish = new EventEmitter<boolean>();

  public oldNoteDisplayName: string = '';
  public newNoteDisplayName: string = '';

  constructor(private bsModalRef: BsModalRef, private articleDataService: ArticleDataService) { }

  ngOnInit() {
    this.loadNoteForData(this.oldData, (value: string) => this.oldNoteDisplayName = value);
    this.loadNoteForData(this.newData, (value: string) => this.newNoteDisplayName = value);
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public selectPreselection(useNewValues: boolean) {
    this.close();
    this.finish.emit(useNewValues);
  }

  private loadNoteForData(data: FinalizationPreselectionVO, setNoteCallback: (value: string) => void): void {
    if (data) {
      this.articleDataService.loadMainNotesForTypeClassId(data.classId).subscribe(
        (loadedNotes: any[]) => {
          const foundNote = loadedNotes.find(note => note.attributeId === data.mainNote);
          if (foundNote) {
            setNoteCallback(foundNote.displayName);
          } else {
            setNoteCallback(data.mainNote ? `${data.mainNote}` : '');
          }
        },
        () => setNoteCallback(data.mainNote ? `${data.mainNote}` : ''));
    }
  }
}
